module.exports = __webpack_public_path__ + "img/codepen.171c0ddb.svg";